import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import {
  Address,
  CompanyVendor,
  Contact,
  Contract,
  ExemptVendor,
  File,
  Vendor
} from 'src/app/classes/models';
import { CompanyVendorService } from 'src/app/services/company-vendor.service';
import { ContractService } from 'src/app/services/contract.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-client-my-vendors-contract-details',
  templateUrl: './client-my-vendor-contract-details.component.html',
  styleUrls: ['./client-my-vendor-contract-details.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClientMyVendorContractDetailsComponent implements OnInit {
  constructor(
    private Route: ActivatedRoute,
    private ContractService: ContractService,
    private CompanyVendorService: CompanyVendorService,
    private ToastService: ToastService,
    private UtilityService: UtilityService
  ) {}

  @Input() ContractId: number | null = null;

  Vendor: Vendor | ExemptVendor | null = null;
  Contract: Contract | null = null;
  Files: File[] | null = [];
  Address: Contact | Address | null = null;
  overallVendorRating: number = 0;

  primaryContact: Contact | null = null;
  contractDetails: Map<string, number | string | Date> = new Map();

  isAddress(address: any): address is Address {
    return (
      address.isMailing !== undefined ||
      address.isStreet !== undefined ||
      address.isRemitTo !== undefined
    );
  }

  ngOnInit(): void {
    const paramMap: ParamMap = this.Route.snapshot.paramMap;
    const VendorId = Number(paramMap.get('VendorId')) || null;
    const ExemptVendorId = Number(paramMap.get('ExemptVendorId')) || null;
    const ContractId = Number(paramMap.get('ContractId')) || null;
    const companyVendorQueryObj = {
      attributes: JSON.stringify(['overallVendorRating'])
    };

    const vendorQuery = {
      Contact: {
        Address: {}
      }
    };

    if (ContractId) {
      this.ContractId = ContractId;
    }

    const contractQueryObj = {
      id: this.ContractId,
      Contacts: JSON.stringify({}),
      File: JSON.stringify({})
    };

    if (VendorId) {
      Object.assign(contractQueryObj, {
        VendorId,
        Vendor: JSON.stringify(vendorQuery)
      });

      Object.assign(companyVendorQueryObj, { VendorId });
    }

    if (ExemptVendorId) {
      Object.assign(contractQueryObj, {
        ExemptVendorId,
        ExemptVendor: JSON.stringify(vendorQuery)
      });

      Object.assign(companyVendorQueryObj, { ExemptVendorId });
    }

    this.CompanyVendorService.getCompanyVendor(companyVendorQueryObj).subscribe(
      {
        next: (CompanyVendor: CompanyVendor) => {
          if (CompanyVendor) {
            const { overallVendorRating } = CompanyVendor;

            if (overallVendorRating) {
              this.overallVendorRating = overallVendorRating;
            }
          }
        }
      }
    );

    this.ContractService.getContract(contractQueryObj).subscribe({
      next: (Contract: Contract) => {
        if (!Contract) {
          throw this.ToastService.addErrorToast('Error', 'No Contract Found!', {
            returnError: true
          });
        }

        this.Contract = Contract;

        const { Vendor, ExemptVendor, Files } = Contract;

        if (Files && Files.length > 0) {
          this.Files = Files;
        }

        if (Vendor) {
          this.Vendor = Vendor;
        }

        if (ExemptVendor) {
          this.Vendor = ExemptVendor;
        }

        if (!this.Vendor) {
          throw this.ToastService.addErrorToast(
            'Error',
            'No Vendor found on contract',
            { returnError: true }
          );
        }

        const { Contacts } = this.Vendor;

        if (Contacts && Contacts.length > 0) {
          const primaryContact = Contacts.filter(
            (contact) => contact.isPrimaryCompliance === true
          );

          if (primaryContact && primaryContact.length === 1) {
            this.primaryContact = primaryContact[0];

            const { Addresses } = this.primaryContact;

            this.Address = this.primaryContact;

            if (Addresses && Addresses.length > 0) {
              const address = Addresses.filter((address) => address.isMailing);

              if (address && address.length > 0) {
                this.Address = address[0];
              }
            }
          }
        }
      }
    });
  }
}
